import { utils } from '@hh/global.js'

const { prefersReducedMotion, fadeInAnimation } = utils
class LoadMore extends HTMLElement {
  connectedCallback() {
    this.nextPageURL = this.dataset.nextPage
    this.grid = document.querySelector('.js-grid')
    this.originalLastItem = this.grid.querySelector('li:last-of-type a')
    this.getNextPage = this.getNextPage.bind(this)
    this.addEventListener('loadMore', this.getNextPage)
  }

  disconnectedCallback() {
    this.removeEventListener('loadMore', this.getNextPage)
  }

  getNextPage() {
    fetch(this.nextPageURL)
      .then((response) => response.text())
      .then((responseText) => {
        const newGrid = new DOMParser()
          .parseFromString(responseText, 'text/html')
          .querySelector('.js-grid').innerHTML
        const newLoadMore = new DOMParser()
          .parseFromString(responseText, 'text/html')
          .querySelector('.js-load-more-region')

        this.grid?.insertAdjacentHTML('beforeend', newGrid)
        if (newLoadMore) {
          this.grid.insertAdjacentElement('afterend', newLoadMore)
        }

        if (!prefersReducedMotion()) {
          fadeInAnimation([
            ...document.querySelectorAll(
              '.js-card:not(.fadein), .js-grid-fade-in:not(.fadein)'
            ),
          ])
        }

        setTimeout(() => {
          this.originalLastItem?.focus()
        }, 0)

        this.executeScripts(newGrid)

        this.remove()
      })
  }

  executeScripts(responseText) {
    const newDocument = new DOMParser().parseFromString(responseText, 'text/html')
    const scripts = newDocument.querySelectorAll('script')

    scripts.forEach(script => {
      const newScript = document.createElement('script')
      newScript.text = script.textContent
      document.head.appendChild(newScript).parentNode.removeChild(newScript)
    })
  }
}

customElements.define('hh-load-more', LoadMore)
